export const formatMoney = (amount) => {
  return new Intl.NumberFormat('es-CL', { style: 'currency', currency: 'CLP' }).format(amount);
}

export const truncateText = (text, maxLength) => {
  if (text.length <= maxLength) {
    return text;
  }
  return text.substring(0, maxLength) + '...';
};

export const validateRut = (rut) => {
  if (typeof rut !== 'string') {
    return false;
  }
  // Quitar puntos y espacios (mantener guión), convertir a mayúsculas
  const rutNorm = rut.replace(/[.\s]/g, '').toUpperCase();
  // Validar formato: uno o más dígitos + guión + dígito verificador (0-9 o K)
  // Mismo patrón que app móvil (SignupScreen.js / DataPersonalScreen.js)
  if (!/^[0-9]+-[0-9K]{1}$/.test(rutNorm)) {
    return false;
  }

  // Limpiar completamente (quita el guión también) para el cálculo
  const rutClean = clean(rut); // devuelve solo dígitos + K en mayúsculas

  let t = parseInt(rutClean.slice(0, -1), 10);
  let m = 0;
  let s = 1;

  // Algoritmo módulo 11 — idéntico a función dv() de Sima-appmovil/SignupScreen.js
  while (t > 0) {
    s = (s + (t % 10) * (9 - m++ % 6)) % 11;
    t = Math.floor(t / 10);
  }

  const v = s > 0 ? String(s - 1) : 'K';
  return v === rutClean.slice(-1);
};
/**
 * Normaliza un valor de RUT antes de validarlo o enviarlo:
 * - Reemplaza guiones Unicode (U+2010-U+2014 y U+2212) por guion ASCII.
 * - Elimina caracteres invisibles (NBSP U+00A0, ZWSP U+200B, ZWNJ U+200C,
 *   ZWJ U+200D, BOM U+FEFF).
 * - Aplica cleanRut (quita puntos y espacios, pasa a mayusculas, conserva el guion).
 *
 * Se usa comparacion de charCode para evitar literales Unicode en el codigo fuente
 * y asi no disparar las reglas no-misleading-character-class / no-irregular-whitespace.
 *
 * Movida acá desde ModalCredential.jsx (donde vivía privada) para que
 * src/lib/sesionTokens.js la use al derivar el header `rut` de la claim del
 * access token (CA-6, ver CLAUDE.md § Sesión JWT / token invitado).
 */
export const normalizarRut = (value) => {
  if (!value) return "";
  let v = "";
  for (let i = 0; i < value.length; i++) {
    const code = value.charCodeAt(i);
    // Guiones Unicode a ASCII:
    // 8208-8212 = U+2010 HYPHEN ... U+2014 EM DASH
    // 8722      = U+2212 MINUS SIGN
    if ((code >= 8208 && code <= 8212) || code === 8722) {
      v += "-";
    // Caracteres invisibles a eliminar:
    // 160   = U+00A0 NBSP
    // 8203  = U+200B ZERO WIDTH SPACE
    // 8204  = U+200C ZERO WIDTH NON-JOINER
    // 8205  = U+200D ZERO WIDTH JOINER
    // 65279 = U+FEFF BOM / ZERO WIDTH NO-BREAK SPACE
    } else if (code === 160 || (code >= 8203 && code <= 8205) || code === 65279) {
      // eliminar
    } else {
      v += value[i];
    }
  }
  return cleanRut(v);
};

export const cleanRut = (rut) => {
  if (!rut) {
    return ''; // Devuelve cadena vacía si el valor es null, undefined o vacío.
  }
  
  // ⭐️ SOLUCIÓN: La expresión regular ahora solo busca eliminar puntos (.) y espacios en blanco (\s).
  // El guion (-) y los números/letras se mantienen.
  return String(rut)
    .replace(/[.\s]/g, '') // Elimina puntos y espacios en blanco
    .toUpperCase(); // Convierte a mayúsculas
};

const clean = (rut) => {
  if (!rut) {
    return ''; // Devuelve cadena vacía si el valor es null, undefined o vacío.
  }
  // Elimina puntos, guiones y convierte a mayúsculas
  return String(rut).replace(/[^0-9kK]/g, '').toUpperCase();
};

export const formatRut = (rut) => {
  rut = clean(rut)

  let result = rut.slice(-4, -1) + '-' + rut.substr(rut.length - 1)
  for (let i = 4; i < rut.length; i += 3) {
    result = rut.slice(-3 - i, -i) + '.' + result
  }

  return result
}

export const formatPercentage = (percentage) =>{
  return percentage.toFixed(0);
}

export const currentDate = () => {
  const today = new Date();
  const month = today.getMonth()+1;
  const year = today.getFullYear();
  const date = today. getDate();

  return date + "-" + month + "-" + year;
}

export const processDate = (date) => {
  var parts = date.split("-");
   return new Date(parts[2], parts[1] - 1, parts[0]);
}

export const  dateToDDMMYYYY = (date) => {
  const newdate = new Date(date);

  const day = String(newdate.getDate()).padStart(2, '0'); // Añade un '0' al principio si es un solo dígito
  const month = String(newdate.getMonth() + 1).padStart(2, '0'); // getMonth() es base 0 (0 para enero)
  const year = newdate.getFullYear();

  // Retorna la fecha en el formato deseado
  return `${day}-${month}-${year}`;
}

export const validateEmail = (email) => {
  // A standard regular expression for validating email addresses
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

// Mapea el carrito de Zustand al formato que espera createOrder: agrega
// 'cantidad' como alias de producto_cant y filtra por la máquina del pedido.
// Compartido entre los flujos de Webpay, OneClick y Mercado Pago para evitar
// que el shape diverja entre copias (ver Incidencia CardOneClick descdesc_tipo_nombre).
export const mapCartForOrder = (products, storeId) => {
  return products
    .filter((item) => item.maquina_id == storeId && Number(item.producto_cant) > 0)
    .map((item) => ({ ...item, cantidad: item.producto_cant }));
};

// Arma el objeto appliedDiscount que espera createOrder a partir del cupón
// aplicado en el carrito (descuento_data/descuento_id de useProductStore).
// El backend (createOrder.post.ts) compara "tipo" contra los strings compuestos
// total_porcentaje/total_monto/total_2x1/productos_porcentaje/productos_monto,
// no contra el desc_tipo_nombre crudo ("porcentaje"/"monto fijo"/"2x1") que
// devuelve la API de descuentos — hay que combinarlo con el alcance del cupón
// (total vs. productos específicos), igual que ya infiere CartPage.jsx vía
// data.productos == null, y como hace Sima-appmovil (CarShopingScreen.js).
export const buildAppliedDiscount = (descuentoData, descuentoId) => {
  if (!descuentoData) return null;

  const aplicaProductos = descuentoData.productos != null;
  let tipo;
  if (descuentoData.desc_tipo_nombre === "2x1") {
    tipo = aplicaProductos ? "productos_2x1" : "total_2x1";
  } else if (descuentoData.descuento_tipo_id === 2) {
    tipo = aplicaProductos ? "productos_monto" : "total_monto";
  } else if (descuentoData.descuento_tipo_id === 3) {
    tipo = aplicaProductos ? "productos_porcentaje" : "total_porcentaje";
  } else {
    tipo = descuentoData.desc_tipo_nombre || "";
  }

  return {
    tipo,
    valor: descuentoData.descuento_valor || "",
    descuento_id: descuentoId || 0,
    descuento_nombre: descuentoData.descuento_nombre || "",
    simbolo: descuentoData.descuento_tipo_simbolo || "",
  };
};

export const getDistance = (lat1, lon1, lat2, lon2) =>{
  const R = 6371; // Radio de la Tierra en kilómetros
  const toRadians = (deg) => deg * (Math.PI / 180);

  const dLat = toRadians(lat2 - lat1);
  const dLon = toRadians(lon2 - lon1);

  const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(toRadians(lat1)) * Math.cos(toRadians(lat2)) *
      Math.sin(dLon / 2) * Math.sin(dLon / 2);

  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  const distancia = R * c; // Distancia en kilómetros
  return distancia.toFixed(2);
}

